import { render, staticRenderFns } from "./childrenStories.vue?vue&type=template&id=3f811f07&"
import script from "./childrenStories.vue?vue&type=script&lang=js&"
export * from "./childrenStories.vue?vue&type=script&lang=js&"
import style0 from "./childrenStories.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports